import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: true,
  name: 'compactCurrency',
})
export class CompactCurrencyPipe implements PipeTransform {

  transform(value?: number): string {
    if(value === undefined || isNaN(value)) return 'N/A';

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      notation: 'compact',
      maximumFractionDigits: 2,
    }).format(value);
  }

}
